import React, { useEffect, useState, useRef } from 'react';
 import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
//import PaginationTable from '../../pagination/Pagination4'; 

import FPS_Day_Month_Trans_Details from './FPS_Day_Month_Trans_Details';



const VersionUpdateAbstract_data = async (parms) => {
   // console.log("Sending API Request with:", parms); // Log request payload
  const response = await fetch(`${process.env.REACT_APP_URL_MIS}/api/active_inactive_list`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      
    },
    body: JSON.stringify(parms),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
};

const VersionUpdateAbstract  = ({status,dist_code}) => {

   // console(type + dist_code    +"in side....")
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  //const [page, setPage] = useState(0);
 // const [rowsPerPage, setRowsPerPage] = useState(100);
  const fpscardstab = useRef(null); // Use ref to scroll to this div
  //const [version, setVersion] = useState(null);
        const [renderContenttttt, setRenderContenttttt] = useState(null);
  

        const today = new Date();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // "03"
        const year = today.getFullYear();
      


  const handleDistClick = (status,fps_id, month, year) => {
    setRenderContenttttt(
      status === 'D' ? (
        <FPS_Day_Month_Trans_Details  
          status={status}
          fps_id={fps_id}
          month={month}
          year={year}
        />
      ) : (
        <FPS_Day_Month_Trans_Details  
          status={status}
          fps_id={fps_id}
          month={month}
          year={year}
        />
      ),1
    );
  };
  




  useEffect(() => {
    const getData = async () => {
      try {
        const response_data = await VersionUpdateAbstract_data({status,dist_code});
        console.log("Fetching data with Status:", status, "and dist_code:", dist_code);


        
        console.log(status  +"...type");
        console.log(dist_code);
        console.log(response_data);

       // setTabHeading(response_data.heading);
        if (response_data.data && response_data.data.length > 0) {
          setTabHeading(response_data.heading);

            setReportData(response_data.data);
        } else {
          setReportData([]);
        }
      } catch (errorr) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [status,dist_code ]);
/*
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  /*
  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
    setPage(0); // Reset page to 0 when changing rows per page
  };
*/
  
  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && fpscardstab.current) {
        fpscardstab.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [loading, error, reportData]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }
  if (error) {
    return <div className="mainhead" align="center">Internal Error</div>;
  }
  console.log(reportData.length  +"...reportData.length ")
  // if (reportData.length === 0) {
  //   return <div className="mainhead" align="center">No data found</div>;
  // }


     if (!reportData || !Array.isArray(reportData) || reportData.length === 0) {
    return <div className="mainhead" align="center">
        No data found
    </div>
}

  // Pagination logic
  {/*
  const paginatedData = rowsPerPage === 'all' 
    ? reportData 
    : reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);   */}


/*

*/ 

//...to apply colour to heading 
const getFormattedHeading = (tabHeading, reportData) => {
  if (!tabHeading) { 
    return "No Heading Available";  
}

if (!Array.isArray(reportData) || reportData.length === 0) { 
    return tabHeading;  
}

const distNameEn = reportData[0]?.dist_name_en || reportData[0]?.data?.dist_name_en;
const MESSAGE=  reportData[0]?.message || reportData[0]?.data?.message;

const highlightWords1 = distNameEn;

const highlightWords2 = MESSAGE;

return (
    <>
        {tabHeading.split(" ").map((word, index) => {
            if (highlightWords1.includes(word)) {
                return <span key={index} style={{ color: "orange", fontWeight: "bold" }}>{word} </span>;
            }
            if (highlightWords2.includes(word)) {
                return <span key={index} style={{ color: "yellow", fontWeight: "bold" }}>{word} </span>;
            }
            return <span key={index}>{word} </span>;
        })}
    </>
);
};  





//console.log(tabHeading); 

  return (
    <>
      <table ref={fpscardstab} align="center" width="65%" border={1}>
        <thead>
          <tr className="tableheader">
          <th colSpan={11}>
    {getFormattedHeading(tabHeading, reportData)} 
</th>    
        </tr>
          <tr className="tableheader">
            <th rowspan={2}>Sl.No</th>
            <th rowspan={2}>JSO</th>
            <th rowspan={2}>FPS</th>
            <th rowspan={2}>Dealer Name</th>
            <th rowspan={2}>Dealer Mobile</th>
          
	    	  	<th>Total<br/>Cards</th>
	      		<th>Today<br/>1st Login</th>
	    	  	<th>Today<br/>last Login</th>
		      	<th>Today<br/>Availed Cards </th>
		      	<th>Month<br/>Availed Cards</th>
		      	<th>Avail<br/>Percentage</th>
		
          </tr>
          
        </thead>
        <tbody>
          {reportData.map((item, index) => (

            
            <tr key={item.fps_id}>
          {/*    <td style={{ textAlign: 'center' }}>{rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}</td> {/* Adjusted Sl.No */}
             
          <td style={{ textAlign: 'left' }}>{index+1}</td>

              <td style={{ textAlign: 'left' }}>{item.afso_name_en}</td>
              <td style={{ textAlign: 'left' }}>{item.fps_id}</td>  
             

              <td style={{ textAlign: 'left' }}>{item.del_name}</td>
              <td style={{ textAlign: 'left' }}>{item.del_mob}</td>
              <td style={{ textAlign: 'left' }}>{item.abst_cards}</td>

              <td style={{ textAlign: 'left' }}>{item.auth_time}</td>

              <td style={{ textAlign: 'right' }}>{item.last_auth_time}</td>  



              <td style={{ textAlign: 'left' }}>
                                    <a
                                        style={{ cursor: 'pointer', color: 'blue' }}
                                        onClick={() => handleDistClick('M',item.fps_id,month,year,)}
                                    >
                                        {item.day_avail_cards}
                                    </a>
                                </td>
          

              <td style={{ textAlign: 'left' }}>
                                    <a
                                        style={{ cursor: 'pointer', color: 'blue' }}
                                        onClick={() => handleDistClick('M',item.fps_id,month,year,)}
                                    >
                                        {item.month_avail_cards}
                                    </a>
                                </td>



              <td style={{ textAlign: 'right' }}>{item.percentage}</td>


            </tr>
          ))}
        </tbody>
      </table>
      <br /><br />
      <div width="75%" style={{display:'flex', justifyContent:'right',alignItems:'start' , width:'95%'}}> 
   {/*   <PaginationTable
        count={reportData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage} 
      />  */} </div>
      {renderContenttttt && (
        <div>
          {renderContenttttt}
        </div>
      )}

    </>
  );
};

export default VersionUpdateAbstract ;
